const ExecuteAll = (pmsArray) => {
  if (!pmsArray || (pmsArray.length === 0)) {
    return Promise.resolve([]);
  }
  return new Promise((resolve, reject) => {
    let remainingCount = pmsArray.length;
    const results = new Array(pmsArray.length);
    const errors = new Array(pmsArray.length);
    const pmsFinished = () => {
      remainingCount -= 1;
      if (!remainingCount) {
        const error = errors.find(e => e);
        if (error) {
          reject(error);
        } else {
          resolve(results);
        }
      }
    };
    pmsArray.forEach((pms, i) => {
      pms.then((result) => {
        results[i] = result;
        pmsFinished();
      }).catch((err) => {
        errors[i] = err;
        pmsFinished();
      });
    });
  });
};

export { ExecuteAll }; // eslint-disable-line import/prefer-default-export

